import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { getTileFactory } from "../tileFactory";
import { registerLayers } from "../utils";
export var Base = /*#__PURE__*/function () {
  function Base() {
    _classCallCheck(this, Base);

    _defineProperty(this, "tileCache", new Map());
  }

  _createClass(Base, [{
    key: "hasTile",
    value: function hasTile(tile) {
      return !!this.tileCache.has(tile.key);
    }
  }, {
    key: "addTile",
    value: function addTile(tile) {
      var _tile$layerIDList;

      // oldTile 存在的时候暂时直接结束
      // TODO：合并不存在的时候
      if (this.hasTile(tile)) return {
        layers: [],
        layerIDList: []
      }; // 存储当前 tile

      this.tileCache.set(tile.key, tile); // 创建 tile 对应的 layers

      var layerCollections = this.tileFactory.createTile(tile, this.initOptions); // regist layer 将创建出来的 layer 进行注册初始化操作

      registerLayers(this.parent, layerCollections.layers);

      (_tile$layerIDList = tile.layerIDList).push.apply(_tile$layerIDList, _toConsumableArray(layerCollections.layerIDList)); // add layer into layerGroup


      this.addChildren(layerCollections.layers);
      layerCollections.layers.map(function (layer) {
        layer.once('modelLoaded', function () {
          tile.layerLoad();
        });
      });
      return layerCollections;
    }
  }, {
    key: "removeTile",
    value: function removeTile(tile) {
      this.tileCache.delete(tile.key);
      this.removeChildren(tile.layerIDList, false);
    }
  }, {
    key: "addChild",
    value: function addChild(layer) {
      this.children.push(layer);
    }
  }, {
    key: "addChildren",
    value: function addChildren(layers) {
      var _this$children;

      (_this$children = this.children).push.apply(_this$children, _toConsumableArray(layers));
    }
  }, {
    key: "removeChildren",
    value: function removeChildren(layerIDList) {
      var refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var remveLayerList = [];
      var cacheLayerList = [];
      this.children.filter(function (child) {
        layerIDList.includes(child.id) ? remveLayerList.push(child) : cacheLayerList.push(child);
      });
      remveLayerList.map(function (layer) {
        return layer.destroy(refresh);
      });
      this.children = cacheLayerList;
    }
  }, {
    key: "removeChild",
    value: function removeChild(layer) {
      var layerIndex = this.children.indexOf(layer);

      if (layerIndex > -1) {
        this.children.splice(layerIndex, 1);
      }

      layer.destroy();
    }
  }, {
    key: "getChildren",
    value: function getChildren(layerIDList) {
      return this.children.filter(function (child) {
        return layerIDList.includes(child.id);
      });
    }
  }, {
    key: "getChild",
    value: function getChild(layerID) {
      return this.children.filter(function (child) {
        return child.id === layerID;
      })[0];
    }
  }, {
    key: "clearChild",
    value: function clearChild() {
      this.children.forEach(function (layer) {
        layer.destroy();
      });
      this.children.slice(0, this.children.length);
    }
  }, {
    key: "hasChild",
    value: function hasChild(layer) {
      return this.children.includes(layer);
    }
  }, {
    key: "initTileFactory",
    value: function initTileFactory() {
      var source = this.parent.getSource();
      var TileFactory = getTileFactory(this.parent.type, source.parser);
      this.tileFactory = new TileFactory({
        parent: this.parent,
        mapService: this.mapService,
        rendererService: this.rendererService
      });
    }
  }, {
    key: "getSourceLayer",
    value: function getSourceLayer(parentParserType, sourceLayer) {
      if (parentParserType === 'geojsonvt') {
        return 'geojsonvt';
      } else if (parentParserType === 'testTile') {
        return 'testTile';
      } else {
        return sourceLayer;
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {}
  }]);

  return Base;
}();